import Controller from '@ember/controller';

export default class AuthenticatedTeamsController extends Controller {}
